export default __webpack_public_path__ + "static/media/Helm of Shattered Existance.22445d47.jpg";